export class CommitterMaintenanceStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retired",
            "baseName": "retired",
            "type": "number",
            "format": ""
        },
        {
            "name": "expired",
            "baseName": "expired",
            "type": "number",
            "format": ""
        },
        {
            "name": "enqueued",
            "baseName": "enqueued",
            "type": "number",
            "format": ""
        },
        {
            "name": "reclusterSources",
            "baseName": "reclusterSources",
            "type": "number",
            "format": ""
        },
        {
            "name": "reclusterOutputs",
            "baseName": "reclusterOutputs",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CommitterMaintenanceStats.attributeTypeMap;
    }
    constructor() {
    }
}
